module.exports = __webpack_public_path__ + "img/Tiktok-code.125690b9.jpg";